 export const d = [
    {
        ACV: [
                { name: "Calorías", amount: "25" },
                { name: "Carbohidratos totales", amount: "6 g", dailyValue: "2%*"},
                { name: "Azúcares totales", amount: "0 g" },
                { name: "Vitamina B6", amount: "1 mg", dailyValue: "59%*"},
                { name: "Folato (Ácido Fólico)", amount: "400 mcg DFE (240 mcg ácido fólico)", dailyValue: "100%*"},                
                { name: "Vitamina B12", amount: "2.4 mcg", dailyValue: "100%*"},
                { name: "Yodo", amount: "100 mcg", dailyValue: "67%*"},
                { name: "Sodio", amount: "10 mg", dailyValue: "< 1%*"},
                { name: "Vinagre de Manzana (en polvo)", amount: "1000 mg"},
                { name: "Jugo de Granada (en polvo)", amount: "80 mcg"},
                { name: "Jugo de Remolacha (en polvo)", amount: "80 mcg"},
            ],
            suggestedUse: "Uso sugerido: Para resultados óptimos de 2 a 4 gomitas al día, preferiblemente con la primera comida del día (Si te encanta el sabor y no puedes detenerte puede tomar máximo 12 en un día).",
            notContainTitle: "Nuestras gomitas NO contienen:",
            notContain:
                "Levadura, trigo, leche, huevos, gluten, soya, gelatina, maní, mariscos, lácteos, colorantes o saborizantes sintéticos, agave ni salicilatos."
},
{
        Colagen: [
            { name: "Calorías", amount: "10" },
            { name: "Carbohidratos totales", amount: "2.5 g", dailyValue: "1%*" },
            { name: "Azúcares totales", amount: "0 g" },
            { name: "Colágeno Hidrolizado (Tipos I, II, III, V y X)", amount: "2500 mg"},
            { name: "Biotina", amount: "15000 mcg" },
            { name: "Musgo Marino Irlandés (Irish Sea Moss)", amount: "500 mg"},
            { name: "Queratina", amount: "300 mg" },
            { name: "Aceite de Coco", amount: "200 mg" },
            { name: "Extracto de Raíz de Remolacha", amount: "150 mg" },
            { name: "Ácido Hialurónico", amount: "100 mg" },
            { name: "Ácido Pantoténico", amount: "5 mg", dailyValue: "100%*"  },
            { name: "Folato", amount: "400 mcg", dailyValue: "100%*"  },
            { name: "Vitamina A", amount: "900 mcg", dailyValue: "100%*"  },
            { name: "Vitamina B12", amount: "2.4 mcg", dailyValue: "100%*"  },
            { name: "Vitamina C", amount: "90 mg", dailyValue: "100%*"  },
            { name: "Vitamina D", amount: "20 mcg", dailyValue: "100%*"  },
            { name: "Vitamina E", amount: "15 mg", dailyValue: "100%*"  },
            { name: "Zinc", amount: "11 mg", dailyValue: "100%*"  },
            
        ],
        suggestedUse: "Uso sugerido: Toma 2 gomitas al día.",
        notContainTitle: "Nuestras gomitas NO contienen:",
        notContain:
            "Levadura, trigo, leche, huevos, gluten, soya, gelatina, maní, mariscos, lácteos, colorantes o saborizantes sintéticos, agave ni salicilatos."
},
{
        Ash: [
            { name: "Calorías", amount: "12" },
            { name: "Carbohidratos totales", amount: "3 g", dailyValue: "1%*" },
            { name: "Azúcares totales", amount: "0 g" },
            { name: "Vitamina D2", amount: "100 mcg" , dailyValue: "500%*"},
            { name: "Vitamina C", amount: "100 mcg", dailyValue: "111%*" },
            { name: "Zinc", amount: "5 mg", dailyValue: "50%*" },
            { name: "Raíz de Ashwagandha (como Withania somnifera) Extracto 1:20", amount: "1000 mg" }
        ],
        suggestedUse: "Uso sugerido: Toma 2 gomitas al día, preferiblemente con agua y comida en el estómago.",
        notContainTitle: "Nuestras gomitas NO contienen:",
        notContain:
            "Levadura, trigo, leche, huevos, gluten, soya, gelatina, maní, mariscos, lácteos, edulcorantes, colorantes o saborizantes artificiales, agave, conservantes artificiales ni salicilatos."
},
{
        CreatinGummy: [
            { name: "Calorías", amount: "7.5" },
            { name: "Carbohidratos totales", amount: "2 g", dailyValue: "1%*" },
            { name: "Azúcares totales", amount: "0 g" },
            { name: "Creatina Monohidratada", amount: "2.5 g"}
        ],
       suggestedUse: "Uso sugerido: Toma 2 gomitas al día.",
        notContainTitle: "Nuestras gomitas NO contienen:",
        notContain:
            "Levadura, trigo, leche, huevos, gluten, soya, gelatina, maní, mariscos, lácteos, colorantes o saborizantes sintéticos, agave ni salicilatos."
},
{
        Multi: [
            { name: "Calorías", amount: "12" },
            { name: "Carbohidratos totales", amount: "3 g", dailyValue: "1%*" },
            { name: "Azúcares totales", amount: "0 g" },
            { name: "Biotina", amount: "2500 mcg" },
            { name: "Vitamina A", amount: "630 mcg", dailyValue: "70%*" },
            { name: "Vitamina D3", amount: "100 IU", dailyValue: "13%*" },
            { name: "Vitamina B1", amount: "5 mg", dailyValue: "417%*" },
            { name: "Vitamina B2", amount: "5 mg", dailyValue: "385%*" },
            { name: "Vitamina C", amount: "30 mg", dailyValue: "30%*" },
            { name: "Vitamina B6", amount: "5 mg", dailyValue: "294%*" },
            { name: "Vitamina B12", amount: "200 mcg", dailyValue: "833%*" },
            { name: "Calcio", amount: "200 mcg", dailyValue: "16%*" },
            { name: "Yodo", amount: "42 mcg", dailyValue: "28%*" },
            { name: "Zinc", amount: "3 mg", dailyValue: "28%*" },
        ],
        suggestedUse: "Uso sugerido: Toma 2 gomitas al día.",
        notContainTitle: "Nuestras gomitas NO contienen:",
        notContain:
            "Levadura, trigo, leche, huevos, gluten, soya, gelatina, maní, mariscos, lácteos, colorantes o saborizantes sintéticos, agave ni salicilatos."
},
{
        Sleep: [
            { name: "Calorías", amount: "20" },
            { name: "Carbohidratos totales", amount: "5 g", dailyValue: "2%*" },
            { name: "Azúcares totales", amount: "0 g" },
            { name: "Proteína", amount: "< 1 g"},
            { name: "Magnesio", amount: "100 mg", dailyValue: "24%*" },
            { name: "Melatonina", amount: "2 mg"},
            { name: "L-Theanina", amount: "200 mg" }
        ],
       suggestedUse: "Uso sugerido: Toma 2 gomitas al día, 30 a 60 minutos antes de dormir.",
        notContainTitle: "Nuestras gomitas NO contienen:",
        notContain:
            "Levadura, trigo, leche, huevos, gluten, soya, gelatina, maní, mariscos, lácteos, colorantes o saborizantes sintéticos, agave ni salicilatos."
}

];